var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#settings_icon_svg__clip0_1_8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "settings_icon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0v24h24V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#settings_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.521a3.801 3.801 0 002.564-1.06 3.433 3.433 0 001.054-2.46c0-.92-.378-1.803-1.054-2.46A3.8 3.8 0 0012 8.48a3.8 3.8 0 00-2.564 1.06A3.433 3.433 0 008.382 12c0 .92.378 1.803 1.054 2.461A3.801 3.801 0 0012 15.521zm7.65-2.535l2.167 1.643a.486.486 0 01.096.657l-2.07 3.474a.462.462 0 01-.272.216.49.49 0 01-.354-.028l-2.55-.986a7.86 7.86 0 01-1.733.986l-.385 2.629a.484.484 0 01-.161.293.531.531 0 01-.32.13H9.93a.53.53 0 01-.32-.13.483.483 0 01-.16-.293l-.386-2.629a6.311 6.311 0 01-1.732-.986l-2.551.986a.49.49 0 01-.354.028.462.462 0 01-.272-.216l-2.07-3.473a.485.485 0 01.096-.657l2.166-1.643a6.716 6.716 0 01-.048-.986c-.008-.329.008-.658.048-.986L2.182 9.371a.485.485 0 01-.096-.656l2.07-3.475a.462.462 0 01.272-.216.49.49 0 01.354.028l2.55.986a7.855 7.855 0 011.733-.986l.385-2.629a.485.485 0 01.161-.293.532.532 0 01.32-.13h4.138a.53.53 0 01.32.13c.088.077.145.18.16.293l.383 2.63c.63.237 1.215.57 1.732.986l2.551-.986a.49.49 0 01.354-.028.462.462 0 01.272.216l2.072 3.474a.486.486 0 01-.095.657l-2.167 1.643c.04.327.056.656.048.986.008.329-.008.658-.048.986z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings_icon_svg__clip0_1_8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgSettingsIcon;